const VERIFIER_BYTES = 32;

function toBase64Url(bytes: Uint8Array): string {
	let binary = '';

	for (const byte of bytes) {
		binary += String.fromCharCode(byte);
	}

	return btoa(binary).replace(/\+/gu, '-')
		.replace(/\//gu, '_')
		.replace(/[=]+$/u, '');
}

export function generateCodeVerifier(): string {
	const bytes = new Uint8Array(VERIFIER_BYTES);

	crypto.getRandomValues(bytes);

	return toBase64Url(bytes);
}

export async function deriveCodeChallenge(verifier: string): Promise<string> {
	const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(verifier));

	return toBase64Url(new Uint8Array(digest));
}
